import React, { useState, useEffect } from 'react';
import './ReporteVentas.css';
import { RegionService } from '../../../services/RegionService';
import { SaleService } from '../../../services/SaleService';
import Permiso from '../../../router/Permiso';

const ReporteVentas = ({ token, onVentaRecuperada }) => {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filtros, setFiltros] = useState({
    fechaInicio: '',
    fechaFin: '',
    buscarNombre: '',
    vendedores: '',
    regiones: '',
    estado: ''
  });
  const [regionesDisponibles, setRegionesDisponibles] = useState([]);
  const [estados, setEstados] = useState([]);
  const [loadingRegiones, setLoadingRegiones] = useState(false);
  const [filtrosAplicados, setFiltrosAplicados] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);

  useEffect(() => {
    cargarRegiones();
    handleFiltrar();
    cargarEstado();
  }, [token]);

  useEffect(() => {
    handleFiltrar();
  }, [filtros, currentPage]);

  const cargarRegiones = async () => {
    setLoadingRegiones(true);
    try {
      const data = await RegionService.fetchRegiones(token);
      setRegionesDisponibles(data);
    } catch (error) {
      console.error("Error al cargar regiones:", error);
    } finally {
      setLoadingRegiones(false);
    }
  };

  const cargarEstado = async () => {
    try {
      const data = await SaleService.getEstadoVenta(token);
      setEstados(data);
    } catch (error) {
      console.error("Error al cargar estado:", error);
    }
  };

  const handleFiltrar = async () => {
    setLoading(true);
    setError('');
    setFiltrosAplicados(true);

    try {
      const { ventas, totalPaginas, totalRegistros } = await SaleService.fetchVentasReporte({
        token,
        pagina: currentPage,
        pageSize: 20,
        desde: filtros.fechaInicio,
        hasta: filtros.fechaFin,
        nombre: filtros.buscarNombre,
        vendedores: filtros.vendedores,
        estado: filtros.estado,
        regiones: filtros.regiones.length > 0 ? filtros.regiones.join(',') : '',
      });

      setVentas(ventas);
      setTotalPages(totalPaginas);
      setTotalRegistros(totalRegistros);

    } catch (err) {
      console.error('❌ Error al cargar reporte:', err);

      setError('No se pudo cargar el reporte desde el servidor. ');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleMultiSelect = (e, field) => {
    const selectedValues = Array.from(e.target.selectedOptions).map(option => option.value);

    setFiltros(prev => ({
      ...prev,
      [field]: selectedValues
    }));
  };

  const limpiarFiltros = () => {
    setFiltros({
      fechaInicio: '',
      fechaFin: '',
      vendedores: [],
      regiones: []
    });
    setVentas([]);
    setFiltrosAplicados(false);
    setError('');
  };

  const exportarExcel = async () => {
    try {
      const filtrosPara = {
        desde: filtros.fechaInicio,
        hasta: filtros.fechaFin,
        vendedores: filtros.vendedores.length > 0 ? filtros.vendedores.join(',') : '',
        regiones: filtros.regiones.length > 0 ? filtros.regiones.join(',') : '',
      };

      const blob = await SaleService.exportarReporteVentasExcel(token, filtrosPara);

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "ventas.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al exportar Excel:", error);
    }
  };

  const getEstadoClass = (estado) => {
    const estados = {
      'VENTA': 'estado-venta',
      'REPORTADO': 'estado-reportado',
      'PENDIENTE': 'estado-pendiente',
      'NO EXISTE': 'estado-no-existe',
      'INSTALADO': 'estado-instalado',
      'ANULADO': 'estado-anulado',
      'DUPLICADO': 'estado-duplicado'
    };
    return estados[estado] || 'estado-venta';
  };

  return (
    <div className="ventas-admin-content">
      <div className="ventas-admin-header">
        <div className="ventas-admin-header-row">
          <div>
            <div className="ventas-admin-title">Reportes </div>
            <div className="ventas-admin-subtitle">
              Genera reportes detallados con filtros avanzados
            </div>
          </div>
        </div>
        <div className="ventas-admin-tab-content">
          <div className="ventas-admin-container">
            <div className="ventas-table-header">
              <h2 className="ventas-table-title">Reporte de Ventas</h2>
              <div className="productos-actions">
                <Permiso permiso="reporte_venta">
                  <button onClick={exportarExcel} className="btn-exportar" disabled={ventas.length === 0}>
                    Exportar a Excel
                  </button>
                </Permiso>
              </div>
            </div>

            {/* Filtros */}
            <div className="usuarios-filtros">
              <div className="filtro-item">

                <label htmlFor='fechaInicio'>Fecha Inicio:</label>

                <input
                  type="date"
                  name="fechaInicio"
                  value={filtros.fechaInicio}
                  onChange={handleInputChange}
                  placeholder="dd/mm/aaaa"
                />
              </div>
              <div className="filtro-item">

                <label htmlFor='fechaFin'>Fecha Fin:</label>
                <input
                  type="date"
                  name="fechaFin"
                  value={filtros.fechaFin}
                  onChange={handleInputChange}
                  placeholder="dd/mm/aaaa"
                />
              </div>
              <div className="filtro-item">
                <label htmlFor='buscarNombre'>Buscar por Cliente:</label>
                <input
                  type="text"
                  name="buscarNombre"
                  value={filtros.buscarNombre}
                  onChange={handleInputChange}
                  placeholder="Nombre, apellido o Número de Documento"
                />
              </div>
              <div className="filtro-item">
                <label htmlFor='vendedores'>Buscar por Vendedor:</label>
                <input
                  type="text"
                  name="vendedores"
                  value={filtros.vendedores}
                  onChange={handleInputChange}
                  placeholder="Nombre, apellido o Número de Documento"
                />
              </div>
              <div className="filtro-item">
                <label htmlFor='region'>Región </label>
                <div className="multi-select-container">
                  <select
                    value={filtros.regiones.length > 0 ? filtros.regiones[0] : ''}
                    onChange={(e) => handleMultiSelect(e, 'regiones')}
                    className="multi-select"
                  >
                    <option value="">Seleccionar región</option>
                    {regionesDisponibles.length === 0 ? (
                      <option disabled>Cargando regiones...</option>
                    ) : (
                      regionesDisponibles.map((region) => (
                        <option key={region.id} value={region.id}>
                          {region.description}
                        </option>
                      ))
                    )}
                  </select>
                </div>
              </div>

              <div className="filtro-item">
                <label htmlFor='estado'>Estados </label>
                <div className="multi-select-container">
                  <select
                    name='estado'
                    value={filtros.regiones.length > 0 ? filtros.regiones[0] : ''}
                    onChange={handleInputChange}
                    className="multi-select"
                  >
                    <option value="">Seleccionar estado</option>
                    {estados.length === 0 ? (
                      <option disabled>Cargando estado...</option>
                    ) : (
                      estados.map((estado) => (
                        <option key={estado.id} value={estado.id}>
                          {estado.descripcion}
                        </option>
                      ))
                    )}
                  </select>
                </div>
              </div>

              <div className="filtro-item">
                <button onClick={limpiarFiltros} className="btn-limpiar">
                  Limpiar Filtros
                </button>
              </div>

            </div>

            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            {loading ? (
              <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Generando reporte...</p>
              </div>
            ) : (
              <>

                <div className="ventas-table-wrapper">
                  <table className="ventas-table">
                    <thead>
                      <tr>
                        <th>Vendedor</th>
                        <th>Supervisor</th>
                        <th>Cliente</th>
                        <th>Producto</th>
                        <th>Precio</th>
                        <th>Fecha Venta</th>
                        <th>Estado</th>
                        <th>Estado Servicio</th>
                        <th>Fecha Instalación</th>
                        <th>Región</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ventas.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="no-data">
                            {filtrosAplicados
                              ? 'No se encontraron ventas con los filtros aplicados'
                              : 'Aplica filtros para ver el reporte de ventas'
                            }
                          </td>
                        </tr>
                      ) : (
                        ventas.map((venta) => (
                          <tr key={venta.id}>
                            <td>{venta.nombre_vendedor || ''}  {venta.apellido_vendedor}</td>
                            <td>{venta.supervisor || ''}</td>
                            <td>{venta.cliente_nombre} {venta.cliente_apellido_paterno} {venta.cliente_apellido_materno}</td>
                            <td>{venta.nombre_producto || '-'}</td>
                            <td>{venta.precio_producto ? `S/ ${venta.precio_producto}` : '-'}</td>
                            <td>{venta.fecha_venta ? new Date(venta.fecha_venta).toLocaleDateString() : '-'}</td>
                            <td>{venta.estado_cliente}</td>
                            <td>
                              <span className={`estado-venta ${getEstadoClass(venta.estado_servicio)}`}>
                                {venta.estado_servicio || '-'}
                              </span>
                            </td>
                            <td>{venta.fecha_instalacion ? new Date(venta.fecha_programacion).toLocaleDateString() : '-'}</td>
                            <td>{venta.name_region || '-'}</td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>

                <span style={{ marginLeft: "12px", fontSize: "14px", color: "#555" }}>
                  {" "}
                  Total de registros: {totalRegistros}{" "}
                </span>

                <div className="pagination">
                  <button
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                  <span>
                    Página {currentPage} de {totalPages}
                  </span>
                  <button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Siguiente
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default ReporteVentas; 